import { useState } from "react";
import { User } from "lucide-react";

export const UserAvatar = ({ name, picture, size = 32 }) => {
  const [broken, setBroken] = useState(false);
  const initial = (name || "").trim().charAt(0).toUpperCase();

  if (picture && !broken) {
    return (
      <img
        data-testid="header-user-avatar"
        src={picture}
        alt={name || "Profil"}
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
        style={{ width: size, height: size }}
        className="rounded-full object-cover ring-2 ring-[#D2EDE1]"
      />
    );
  }

  return (
    <span
      data-testid="header-user-avatar-fallback"
      style={{ width: size, height: size }}
      className="rounded-full bg-[#D2EDE1] text-[#16233D] font-semibold text-sm flex items-center justify-center ring-2 ring-[#E3E8F1]"
    >
      {initial || <User className="h-4 w-4" />}
    </span>
  );
};
